export const cycleDetailsSelector = state => state.cycleDetails;
